export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {Notification} from 'kpc';
import {bind} from 'kpc';

export default class extends Component {
    static template = template;
    
    @bind
    showCloseDelay() {
        Notification.warning({
            title: '10s后关闭',
            content: '这条通知10s后才会自动关闭',
            duration: 10000,
        });
    }

    @bind
    showStick() {
        Notification.warning({
            title: '不会自动关闭',
            content: '这条通知不会自动关闭，需要手动关闭',
            duration: 0,
        });
    }
}